import { OidcClient } from '@britishcouncil/react-oidc-auth';
import { createAppSettingsContext } from '@britishcouncil/react-common';

import { BulkUploadLinks } from 'types';

export interface AppSettings {
  sentry: { environment: string; release: string };
  userManagerSettings: OidcClient.UserManagerSettings;
  bulkUploadLinks: BulkUploadLinks;
}

export const DEFAULT_APP_SETTINGS: AppSettings = {} as AppSettings;
export const { AppSettingsContext, useAppSettings } = createAppSettingsContext<AppSettings>();
